module.exports = __webpack_public_path__ + "static/media/model.35ec618a.svg";